import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatAttachments = async (addressId) => {
  return await request.get(
    `/HousingStock/address/${addressId}/attachments`,
    {},
    'При загрузке документов по помещению произошла ошибка',
    []
  );
};

const useFlatAttachments = (addressId, options = {}) =>
  useQuery(
    getQueryKeys.flatAttachments(addressId),
    () => getFlatAttachments(addressId),
    {
      placeholderData: [],
      enabled: Boolean(addressId),
      ...options,
    }
  );

export default useFlatAttachments;
